import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import propTypes from 'prop-types';
import { formatTimeAgo } from '../../../util/dates';
import { createSlug } from '../../../util/urlHelpers';
import { NamedLink } from '../../../components';
import Avatar from '../../../components/Avatar/Avatar';
import OptionMenu from '../../../components/OptionMenu/OptionMenu';
import css from './ListingUpdate.module.css';

const SectionReviewsUpdate = props => {
  const { listing, activity, renderBellIcon, reviews, fetchTotalLikesData, authUser } = props;
  const host = listing.author.attributes.profile.displayName;
  const { title } = listing.attributes;
  const listingUrl = `/l/${createSlug(title)}/${listing.id.uuid}`;
  const updateId = activity?.id;
  const slug = createSlug(title);

  const review = useMemo(() => reviews.find(r => r.id.uuid === activity.review.id), [
    reviews,
    activity.review.id,
  ]);

  if (!review) {
    return null;
  }

  return (
    <div key={activity.id} className={css.content}>
      <div>
        <div className={css.flexContainer}>
          <div className={css.avatarContainer}>
            <NamedLink name="ListingPage" params={{ id: listing.id.uuid, slug }}>
              <>
                <Avatar
                  user={listing.author}
                  disableProfileLink
                  className={css.customAvatarSize}
                  listing={listing}
                  useListingImage
                />
                {renderBellIcon}
              </>
            </NamedLink>
          </div>
          <div className={css.propertyNameContainer}>
            <div className={css.propertyName}>
              <NamedLink name="ListingPage" params={{ id: listing.id.uuid, slug }}>
                <FormattedMessage
                  id="ListingPage.activityFeedPropertyName"
                  values={{
                    propertyName: listing.attributes.title,
                  }}
                />
              </NamedLink>
            </div>
            <div className={css.dateWrapper}>
              <span className={css.dateContainer}>
                <p className={css.landownerContainer}>
                  <FormattedMessage
                    id="ListingPage.activityFeedReview"
                    values={{
                      host,
                      reviewRating: review.rating,
                    }}
                  />
                  {' • '}
                  {formatTimeAgo(review?.createdAt)}
                </p>
              </span>
            </div>
          </div>
        </div>
        <div className={css.postWrapper}>
          <div className={css.descriptionStyles}>{review.content}</div>
        </div>
        <OptionMenu
          listingUrl={listingUrl}
          updateId={updateId}
          fetchTotalLikesData={fetchTotalLikesData}
          authUser={authUser}
        />
      </div>
    </div>
  );
};

SectionReviewsUpdate.propTypes = {
  listing: propTypes.object.isRequired,
};

export default SectionReviewsUpdate;
